<template>
	<div class="details-button display-flex flex-wrap" role="button" v-on="$listeners">
		<div class="flex-col-12 flex-centerize">
			<h3 class="reg">Details</h3>
		</div>
		<div class="flex-col-12 flex-centerize">
			<SIcon class="icon" :name="'three-dot-menu'" height="4" width="14" />
		</div>
	</div>
</template>

<script>
import SIcon from '@/components/common/SIcon.vue';
export default {
	name: 'DetailsButton',
	components: { SIcon },
};
</script>

<style lang="scss" scoped>
.details-button {
	width: 100px;
	color: var(--setup-black);
	.icon {
		display: flex !important;
	}
}
</style>
